import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFormContext } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { AddressLookup } from '../../../modules/AddressLookup/components/AddressLookup.js';
import { mapDataToFormValues } from '../../../modules/AddressLookup/utils/map-data-to-form-values.js';
import { validateInputField } from '../../../modules/AddressLookup/utils/validate-input-field.js';
import { useLoggedInCheckout } from '../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';

const AddressLookupWithoutStore = ({ inputFieldName ='streetName' , errorMessage: initialErrorMessage1 , maxLength , validations , validationsWithErrorMessages , label  })=>{
    const { userDetailsState  } = useLoggedInCheckout();
    const [isTouched, setIsTouched] = React.useState(false);
    const [errorMessage1, setErrorMessage] = React.useState(initialErrorMessage1);
    const { addressLookup  } = useCheckoutSettings();
    const { name , onChange , getInitialState , setFieldState  } = useFormContext();
    const initialState1 = getInitialState && getInitialState(inputFieldName);
    const currentForm = React.useMemo(()=>name ? userDetailsState[name] : {}
    , [
        name,
        userDetailsState
    ]);
    const { country  } = useIntl();
    const validateInput = React.useCallback((value, initialErrorMessage = '')=>{
        const { isValid , errorMessage  } = validateInputField(true, value, initialErrorMessage, validations, validationsWithErrorMessages, maxLength);
        setErrorMessage(errorMessage);
        return isValid;
    }, [
        maxLength,
        validations,
        validationsWithErrorMessages
    ]);
    const updateForm = React.useCallback((value, initialRender)=>{
        if (onChange) {
            onChange({
                name: inputFieldName,
                value,
                isTouched: initialRender ? !!(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) : true,
                isValid: validateInput(value)
            });
        }
    }, [
        onChange,
        inputFieldName,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched,
        validateInput
    ]);
    const updateStore = React.useCallback((prefillData)=>{
        prefillData && Object.entries(prefillData).forEach(([key, value])=>{
            const fieldState = getInitialState === null || getInitialState === void 0 ? void 0 : getInitialState(key);
            if (fieldState) {
                setFieldState === null || setFieldState === void 0 ? void 0 : setFieldState(swcHelpers.objectSpread({}, fieldState, {
                    value
                }));
            }
        });
    }, [
        getInitialState,
        setFieldState
    ]);
    const handleOnResult = React.useCallback((data)=>{
        const formattedData = mapDataToFormValues(data, addressLookup);
        updateStore(formattedData);
    }, [
        addressLookup,
        currentForm,
        updateStore,
        country
    ]);
    const handleIsTouched = React.useCallback(()=>{
        setIsTouched(true);
    }, []);
    const handleOnChange = React.useCallback((initialState)=>{
        if (onChange) {
            onChange({
                name: inputFieldName,
                value: initialState.value,
                isTouched: initialState.isTouched || isTouched || Boolean(initialState.value),
                isValid: validateInput(initialState.value, initialErrorMessage1)
            });
        }
    }, [
        initialErrorMessage1,
        inputFieldName,
        isTouched,
        onChange,
        validateInput
    ]);
    React.useEffect(()=>{
        if (!initialState1) {
            return;
        }
        handleOnChange(initialState1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.value,
        initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid
    ]);
    React.useEffect(()=>{
        // Initializing the field in form context so it can be prefilled.
        !(currentForm === null || currentForm === void 0 ? void 0 : currentForm.streetName) && updateForm('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ React.createElement(AddressLookup, {
        displayError: !Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid) && (Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) || isTouched),
        displayIsValid: Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isValid) && (Boolean(initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.isTouched) || isTouched),
        errorMessage: errorMessage1,
        inputFieldName: inputFieldName,
        label: label,
        setIsTouched: handleIsTouched,
        onResult: handleOnResult,
        streetName: (initialState1 === null || initialState1 === void 0 ? void 0 : initialState1.value) || '',
        updateForm: updateForm
    });
};

export { AddressLookupWithoutStore };
//# sourceMappingURL=AddressLookUpWithoutState.js.map
